import React, { useState, useEffect, useCallback } from "react";
import ReactTable from "components/ReactTable/ReactTable.tsx";
import Moment from "react-moment";
import moment from "moment";

import { Card, CardBody, CardHeader, CardTitle, Row, Col, Input, Badge, } from "reactstrap";

import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import TroubleshootingDashboardService from "core/api/TroubleshootingDashboardService";
import { redirectToPath, paths } from "utils/PathService";

const TroubleshootingDashboard = () => {
  const [data, setData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
  const [pageCount, setPageCount] = useState(0);



  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };


  const getStatusBadge = (status) => {
    if (status === 1) {
      return <Badge color="success">Working</Badge>;
    } else if (status === 2) {
      return <Badge color="danger">Failed</Badge>;
    } 
  };

  const getDaysSinceLastWorkingDisplay = (row) => {
   const days = row.original.daysSinceLastWorking;
    const status = row.original.status;
    const isRecovered = status === 1 && days > 0;

   if (days === 0) {
     return <span className="text-muted">-</span>;
    }
   else if (isRecovered) {
     if (days > 30) {
       return <span className="text-muted">30+ days</span>;
     } else {
       return <span className="text-muted">{days} day{days > 1 ? "s" : ""}</span>;
     }
   }

    else if (days <= 3) {
      return <Badge color="warning">{days} day{days > 1 ? "s" : ""}</Badge>;
    }
    else if(days > 30){
      return <Badge color="danger">30+ days</Badge>;
    }else { 
      return <Badge color="danger">{days} days</Badge>;
   }
  }  

  const fetchData = async () => {
    try {
      const date = new Date(selectedDate);
      const response = await TroubleshootingDashboardService.getElevatorsWithIssues(date.toISOString());
      setData(response?.model ?? []);
      setPageCount(response?.count ?? 0);
    } catch (error) {
      console.error("Error fetching troubleshooting data:", error);
      setData([]);
      setPageCount(0);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedDate]);

  return (
    <>
      <PanelHeader
        content={
          <div className="header text-center">
            <h2 className="title">Troubleshooting Dashboard</h2>
          </div>
        }
      />
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <Card>
              <CardHeader>
                <div className="d-flex gap-4 align-items-center justify-content-start mb-2">
                  <CardTitle tag="h4" >Elevators with Issues </CardTitle>

                  <Col md="3">
                    <Input
                      type="date"
                      value={selectedDate}
                      onChange={handleDateChange}
                      className="form-control"
                    />
                  </Col>
                </div>
              </CardHeader>
              <CardBody>
                <ReactTable
                  data={data}
                  columns={[
                    {
                      header: "Elevator Name",
                      accessorKey: "elevatorName",
                    },
                    {
                      header: "Phone Number",
                      accessorKey: "phoneNumber",
                    },
                    {
                      header: "Status",
                      accessorKey: "status",
                      accessorFn: (row) => row.status === 1 ? "Working" : row.status === 2 ? "Failed" : "",
                      cell: ({ row }) => getStatusBadge(row.original.status),
                    },
                    {
                      header: "Call Status",
                      accessorKey: "callStatus",
                      cell: ({ row }) => (
                        <>{row.original.callStatus}</>
                      ),
                    },
                    {
                      header: "Response Code",
                      accessorKey: "responseCode",
                      cell: ({ row }) => (
                        <>{row.original.responseCode}</>
                      ),
                    },
                    {
                      header: "Online Status",
                      accessorKey: "onlineStatus",
                      cell: ({ row }) => (
                        <>{row.original.onlineStatus || "N/A"}</>
                      ),
                    },
                    {
                      header: "Days Not Working",
                      accessorKey: "daysSinceLastWorking",
                      accessorFn: (row) => {
                        if (row.status !== 2 || row.daysSinceLastWorking === 0) return "0 days";
                        if(row.daysSinceLastWorking == 31) return "30+";
                        return `${row.daysSinceLastWorking} days`;
                      },
                      cell: ({ row }) => getDaysSinceLastWorkingDisplay(row),
                    },
                    {
                      header: "Alert Time",
                      accessorKey: "alertDateTime",
                      cell: ({ row }) => (
                        <>
                          {row.original.alertDateTime == null ? (
                            ""
                          ) : (
                            <Moment format="MM/DD/YYYY HH:mm">{row.original.alertDateTime}</Moment>
                          )}
                        </>
                      ),
                    },
                  ]}
                  fetchData={() => { }} //load data here instead so can change when date changes
                  pageCount={pageCount}
                  defaultPageSize={100}
                  getTrProps={(rowData) => {
                    return {
                      onClick: (_, handleOriginal) => {
                        if (rowData && rowData.elevatorId) {
                          redirectToPath(paths.elevator.view(rowData.elevatorId));
                        }
                        if (handleOriginal) handleOriginal();
                      },
                    };
                  }}
                /> 
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default TroubleshootingDashboard;
